



import $ from 'jquery';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Carousel } from 'react-responsive-carousel';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../../node_modules/react-responsive-carousel/lib/styles/carousel.min.css';
import TextField from 'material-ui/TextField';
import * as actions from '../../actions/actions.jsx';
import { withRouter, Link } from 'react-router-dom';

import creditcardlogo from '../../images/credit-cards-vector-icon-.jpg';
import Loader from '../loader/loader.jsx';
import LoaderSmall from "../loader/loadersmall.jsx";
import UserModal from './regmodal.jsx';
import RaisedButton from 'material-ui/RaisedButton';
import GusetNavbar from '../navigation/guestnavbar';
import InputMask from 'react-input-mask';
import android from '../../images/android.png';
import ios from '../../images/ios.png';

import carousel1 from '../../images/carousel-1.jpg';
import carousel2 from '../../images/carousel-5.jpg';
import carousel3 from '../../images/carousel-3.jpg';
import carousel4 from '../../images/carousel-8.jpg';

import carousel5 from '../../images/carousel-6.jpg';
import carousel6 from '../../images/carousel-2.jpg';
import carousel7 from '../../images/carousel-7.jpg';
import carousel8 from '../../images/carousel-4.jpg';

import activateImg from '../../images/iconShopping.svg';
import customerImg from '../../images/iconCustomersupport.svg';
import manageImg from '../../images/icoAccount.png';
import highlitedtext from '../../images/highlitedau.png';
import nzcardholder from '../../images/nzcardholder.png';
import services from '../../services/allservices.jsx';
import { getClientId, getClientSecret, buildClientHeader } from "../../../src/utils/clientAuth.js";
import uuidv4 from 'uuid/v4';
// import servicesau from '../../services/allservicesau.jsx';
// import servicesnz from '../../services/allservicesnz.jsx';

// const services =  localStorage.getItem('pform')==='AU'? servicesau : servicesnz

// const styles = {
//     button: {
//         margin: 12,
//         background: "#2a5194"
//     },
//     exampleImageInput: {
//         cursor: 'pointer',
//         position: 'absolute',
//         top: 0,
//         bottom: 0,
//         right: 0,
//         left: 0,
//         width: '100%',
//         opacity: 0,
//     },
//     customWidth: {
//         width: 150,
//     },
//     focusStyle: {
//         borderTop: "none #333",
//         borderLeft: "none #333",
//         borderRight: "none #333",
//         borderBottom: "2px solid #333"
//     },
//     focusTextStyle: {
//         color: "#333"
//     }
// };
const styles = {
    button: {
        margin: 12,
        background: "#2a5194"
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    },
    underlineDisabledStyle: {
        borderBottom: "1px solid #ccc"
    }
};

const mapStateToProps = state =>
({
    publicKey: state.publicKey.publicKey,
    keyRecieved: state.publicKey.keyRecieved,
    activationcardState: state.getactivationcardReducer.activationcardState
})
const mapDispatchToProps = dispatch =>
({
    fetchPublicKey(keyRecieved) {
        dispatch(
            actions.publicKeyAction(keyRecieved)
        )
    },
    storeCardNumber(cardNumber) {
        dispatch(
            actions.storeCardDetail(cardNumber)
        )
    },
    getactivation(state) {

        dispatch(
            actions.getactivationcardAction(state)

        )
    },
})


const JSEncrypt = window.JSEncrypt
const isTestServer = () => {
    const url = (localStorage.getItem('pform') === 'AU'
        ? process.env.REACT_APP_SERVICEURL_AU
        : process.env.REACT_APP_SERVICEURL_NZ) || '';
    return url.toLowerCase().includes('test');
};
const getMinCardRefLength = () => (isTestServer() ? 6 : 10);
class ActivateNz extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            cardVerificationDone: false,
            mobileVerificationDone: false,
            mobiledisable: true,
            disabled: true,
            expiryDone: false,
            cardVerified: false,
            verification: false,
            rederFeedback: false,
            mobilecardVerified: false,
            mobileverification: false,
            mobilerederFeedback: false,
            mobile: '',
            open: false,
            loader: false,
            title: "Invalid Card Number",
            openModal: false,
            cardType: "",
            emailId: "",
            width: props.innerWidth,
            height: props.innerHeight,
            isPhysical: true,
            isDigital: true,
            cardref: '',
            refCardNo: '',
            otp: '',
            showOTP: false,
            countdown: 300,
            showOTPBtn: false,
            showCardRefTooltip: false,
            refCardNoDisabled: false,
            cvv: '',
            cardExpiry: '',
        };
        this.lastCheckedCardNumber = null;
        this.storeCard = this.storeCard.bind(this)
        this.updateWindowDimentions = this.updateWindowDimentions.bind(this);

        this.isVerifyingCard = false;
        this.verifyDebounceTimer = null;
        this.isVerifyingDigitalCard = false;
    }
    componentWillMount() {
        localStorage.setItem('landing', 'true')
        localStorage.setItem('pform', 'NZ')
    }
    componentDidMount() {
        this.props.fetchPublicKey(false)
        this.updateWindowDimentions();
        window.addEventListener('resize', this.updateWindowDimentions);
        // document.getElementById("cardNumber").focus()

        setTimeout(() => {
            // this.props.fetchPublicKey(false)
            if (localStorage.getItem('RLD') === 'T') {
                localStorage.setItem('RLD', 'F')
                window.location.reload();
            }
        }, 300)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimentions);
    }

    randomIntFromInterval = (min, max) => { // min and max included 
        return Math.floor(Math.random() * (max - min + 1) + min)
    }


    updateWindowDimentions() {
        this.setState({
            width: window.innerWidth + 'px',
            height: (window.innerHeight - 120) + 'px'
        })
        console.log("Size :", `${this.state.width} x ${this.state.height} `)
    }
    handleClose = () => {

        document.getElementById("myModal").style.display = "none"

    }

    onSuggestSelect(suggest) {

    }
    changeToEditView(e) {
        this.setState({ addressComp: false })
    }
    handleBlur() {
        this.setState({ addressComp: true })
    }
    handleDate(e, date) {
        this.setState({
            dateofbirth: date.toString()
        })
    }
    handleSelect(event, index, value) {
        this.setState({
            gender: value
        })
    }
    onChange(e, value) {
        this.setState({
            [e.target.name]: value
        })

    }

    onRefCardNoChange = (e, value) => {
        this.setState({ refCardNo: value }, () => {
            if (this.state.verification) {
                this.resetMobileAndOtp();
                this.setState({ verification: false, cardVerificationDone: false, refCardNoDisabled: false });
            }
        })
    }


    onRefCardNoBlur = (e, value) => {
        const cardInput = document.getElementById('cardNumber');
        if (cardInput && cardInput.value) {
            const digits = cardInput.value.replace(/-/g, '').replace(/_/g, '');
            if (digits.length == 16) {
                this.lastCheckedCardNumber = null;
                this.debouncedCheckCardNumber({ target: { value: cardInput.value } });
            }
        }
    }

    handleClick = () => {
        localStorage.setItem('landingTabs', 'userName1')
        this.setState({
            landingTabs: 'userName1'
        })
    }
    handleRegister = () => {
        localStorage.setItem('landingTabs', 'cardNo')
        this.setState({
            landingTabs: 'cardNo'
        })
    }
    componentWillReceiveProps(nextProps) {
        if (localStorage.getItem('RLD') === 'T') {
            localStorage.setItem('RLD', 'F')
            window.location.reload();
        }
        // if (nextProps.managestate === true) {
        //     let lo = document.getElementById("signin")
        //     lo.classList.add("active")

        //     let lo1 = document.getElementById("signin1")
        //     lo1.classList.add("active")

        //     let cd = document.getElementById("cardno")
        //     cd.classList.remove("active")

        //     let cd1 = document.getElementById("cardno1")
        //     cd1.classList.remove("active")
        // }

        // else {
        //     let lo = document.getElementById("signin")
        //     lo.classList.remove("active")

        //     let lo1 = document.getElementById("signin1")
        //     lo1.classList.remove("active")

        //     let cd = document.getElementById("cardno")
        //     cd.classList.add("active")

        //     let cd1 = document.getElementById("cardno1")
        //     cd1.classList.add("active")
        // }
    }
    onEnterPress = (e) => {
        if (e.keyCode === 13 && e.shiftKey === false) {
            e.preventDefault();
            this.handleLogin();
        }
    }

    handelvalidateusername = (e, value) => {
        if (e.target.name === "userName" && value.length !== 0) {
            $(function () {
                $('#uName').on('keypress', function (e) {

                    if (e.which === 32)
                        return false;
                });
            });
            // if ((e.target.value.length) >= 6) {
            this.setState({
                userName: value
            }, () => {
                if (this.state.userName.length !== 0 && this.state.password.length !== 0) {
                    this.setState({
                        disabled: false
                    })
                } else {
                    this.setState({
                        disabled: true
                    })
                }
            })
            // }else {
            //     this.setState({
            //         correctUsername: false
            //     })
            // }
        } else {
            this.setState({
                disabled: true
            })
        }
    }

    handelvalidatepassword = (e, value) => {
        if (e.target.name === "password" && value.length !== 0) {
            // if ((e.target.value.length) >= 8) {
            this.setState({
                password: value
            }, () => {
                if (this.state.userName.length !== 0 && this.state.password.length !== 0) {
                    this.setState({
                        disabled: false
                    })
                } else {
                    this.setState({
                        disabled: true
                    })
                }
            })
            // }else {
            //     this.setState({
            //         correctPassword: false
            //     })
            // }
        } else {
            this.setState({
                disabled: true
            })
        }
    }


    storeCard() {
        this.setState({
            disabled: false
        })

        // if (this.state.cardref.length === 10) {
        //     this.getVerifyWithOTP();
        // }
        if (this.state.cardref && this.state.cardref.length >= getMinCardRefLength()) {
    this.getVerifyWithOTP();
}
        else {
            // Physical card: if OTP is required, verify it first (getVerifyWithOTP
            // now also lands on PIN/Confirm PIN/Expiry).
            // PIN setup is never skipped for physical cards.
            if (this.state.otpAuthentication === true) {
                this.getVerifyWithOTP();
                return;
            }
            if (this.state.cardType === "A") {
                this.setState({
                    openModal: true
                })
            }
            else if (this.state.cardType === "G" || this.state.cardType === "R") {
                this.props.history.push('/activate-card')
            }
            else {
                this.setState({
                    disabled: true
                })

                setTimeout(function () {
                    window.location.reload(1);
                }, 3000);
            }

            if (this.state.cardType === "G" || this.state.cardType === "R") {
                JSON.stringify(localStorage.setItem('step', 0))
                this.props.history.push('/activate-card')
            }
        }

    }
    handleOldUser = () => {
        this.setState({
            existingUser: "yes",
            stepIndex: 1,
        }, () => {
            JSON.stringify(localStorage.setItem('step', 1))
            localStorage.setItem('existingUser', 'yes')
            setTimeout(() => {
                this.props.history.push('/activate-card')
            }, 500)

        })
    }
    handleNewUser = () => {
        this.setState({
            existingUser: "no",
            stepIndex: 1,
        }, () => {
            JSON.stringify(localStorage.setItem('step', 1))
            localStorage.setItem('existingUser', 'no')
            setTimeout(() => {
                this.props.history.push('/activate-card')
            }, 500)
        })
    }

    onCvvChange = (e) => {
        const cvv = e.target.value;
        this.setState({ cvv }, () => {
            if (this.state.verification) {
                this.resetMobileAndOtp();
                this.setState({ verification: false, cardVerificationDone: false, refCardNoDisabled: false });
            }
        })
    }


    formatExpiryForDisplay = (digits) => {
        if (!digits) return ''
        if (digits.length <= 2) return digits
        return digits.slice(0, 2) + '/' + digits.slice(2)
    }
    onCardExpiryChange = (e) => {
        const digitsOnly = e.target.value.replace(/\D/g, '').slice(0, 4)
        this.setState({ cardExpiry: digitsOnly }, () => {
            if (this.state.verification) {
                this.resetMobileAndOtp();
                this.setState({ verification: false, cardVerificationDone: false, refCardNoDisabled: false });
            }
        })
    }
    debouncedCheckCardNumber = (e) => {
        const value = e.target.value;
        if (this.verifyDebounceTimer) {
            clearTimeout(this.verifyDebounceTimer);
        }
        this.verifyDebounceTimer = setTimeout(() => {
            this.verifyDebounceTimer = null;
            this.checkCardNumber({ target: { value } });
        }, 300);
    }





    triggerVerificationIfReady = () => {
        const cardInput = document.getElementById('cardNumber');
        if (cardInput && cardInput.value) {
            const digits = cardInput.value.replace(/-/g, '').replace(/_/g, '');
            if (digits.length == 16) {
                this.lastCheckedCardNumber = null;
                this.debouncedCheckCardNumber({ target: { value: cardInput.value } });
            }
        }
    }


    async checkCardNumber(e) {

        if (this.state.verification) {
            this.resetMobileAndOtp();
            this.setState({
                verification: false,
                cardVerificationDone: false,
                refCardNoDisabled: false,
            });
        }
        if (this.state.verification === true && this.state.mobileverification === true) {

            this.setState({
                // disabled: false
            })
        }
        else {
            this.setState({
                disabled: true
            })
        }
        let _this = this
        let string = e.target.value;
        const cardNumber = string.replace(/-/g, "");
        const actualCardNumber = cardNumber.replace(/_/g, "");

        localStorage.setItem('acno', actualCardNumber)

        this.setState({
            refCardNoDisabled: false,
            cardType: "",
            mobiledisable: true,
            mobileverification: false,
            mobilecardVerified: false,
            mobilerederFeedback: false,
        })
        if (actualCardNumber.length > 0) {
            this.setState({ isPhysical: true, isDigital: false })
        } else {
            this.setState({ isPhysical: true, isDigital: true })
        }

        JSON.stringify(localStorage.setItem('cdNo', actualCardNumber))
        const { publicKey } = this.props
        // if (actualCardNumber.length >= 16) {
        if (actualCardNumber.length == 16 && this.state.refCardNo &&
            this.state.refCardNo.length > 0 
            // this.state.cvv && this.state.cvv.length === 3 &&
            // this.state.cardExpiry && this.state.cardExpiry.length === 4

        ) {

            if (this.lastCheckedCardNumber === actualCardNumber) {
                return;
            }
            if (this.isVerifyingCard) {
                return;
            }
            this.lastCheckedCardNumber = actualCardNumber;
            this.isVerifyingCard = true;

            this.setState({ cardVerified: true, rederFeedback: false, cardno: cardNumber, mobiledisable: true, title: "Invalid Card Number" })

            if (publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);
                let encrypted = encrypt.encrypt(cardNumber);
                let encryptedCvv = encrypt.encrypt(this.state.cvv);
                 localStorage.setItem("kitNumber",this.state.refCardNo)
                let encryptedCardExpiry = encrypt.encrypt(this.state.cardExpiry);
                let encryptedCardProxy = encrypt.encrypt(this.state.refCardNo);
                this.props.storeCardNumber(encrypted)
                localStorage.setItem("eCardRef", encryptedCardProxy)

                localStorage.setItem("eCard", encrypted)
                localStorage.setItem("eCvv", encryptedCvv)
                localStorage.setItem("eCardExpiry", encryptedCardExpiry)
                this.setState({ cardNumber: encrypted })

                const state = {
                    cardNumber: encrypted,
                    applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                    kitNo: localStorage.getItem('kitNumber'),
                    // cardProxyNo: encryptedCardProxy,
                    // cvv: encryptedCvv,
                    // cardExpiry: encryptedCardExpiry,
                }
                let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
                let gvvid = getClientId();
                let traceId = getClientId();
                await fetch(plink + services.verify_card_number, {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'clientId': gvvid,
                        'clientSecret': getClientSecret(gvvid, actualCardNumber),
                        'X-Trace-Id': traceId,
                        'X-Client-APP': buildClientHeader(),
                    }),
                    body: JSON.stringify(state)
                })
                    .then(response => {
                        if (response.status === 200 || response.status === 201) {

                            response.json().then(function (object) {

                                _this.setState({
                                    cardVerified: false, rederFeedback: true, verification: true, mobiledisable: false, title: '', cardVerificationDone: true,
                                    cardStatus: object.cardStatus,
                                    refCardNoDisabled: true,
                                })

                                let dob = object.specialDate
                                JSON.stringify(localStorage.setItem('dob', dob))
                                localStorage.setItem("cardType", object.cardType)
                                localStorage.setItem("cardTypes", object.cardType)
                                localStorage.setItem("otpValidation", object.otpValidation)
                                const otpAuthentication = object.otpAuthentication === true || object.otpAuthentication === 'true' || object.otpAuthentication === 1;
                                localStorage.setItem("otpAuthentication", otpAuthentication)


                                if (object.cardType !== "A") {

                                    if (!dob) {
                                        _this.setState({
                                            cardType: object.cardType,
                                            disabled: true,
                                            otpAuthentication,
                                            otpValidation: otpAuthentication,
                                            showOTP: false,
                                            showOTPBtn: false,
                                        })
                                    } else {
                                        let dArr = dob.split("-");  // ex input "2010-01-18"
                                        var res = dArr[2].substring(0) + dArr[1].substring(0);

                                        _this.setState({
                                            dob: res,
                                            cardType: object.cardType,
                                            disabled: true,
                                            otpAuthentication,
                                            otpValidation: otpAuthentication,
                                            showOTP: false,
                                            showOTPBtn: false,
                                        })
                                    }
                                }
                                let state = {
                                    cardNumber: object.cardNumber,
                                    expiryDate: object.expiryDate,
                                    firstName: object.firstName,
                                    lastName: object.lastName,
                                }
                                localStorage.setItem("accountId", object.accountId)
                                localStorage.setItem("expiry", object.expiryDate)
                                localStorage.setItem("cardProgram", object.cardProgram)
                                localStorage.setItem("existingUser", object.accountIdExist)
                                localStorage.setItem("isDigitalCard", "false")
                                // _this.props.getactivation(state)
                            })

                        }
                        else if (response.status === 422) {
                            response.json().then(function (object) {
                                const apiMessage = (object && object.message) || response.headers.get('message');

                                _this.setState({
                                    cardVerified: false,
                                    rederFeedback: false,
                                    verification: false,
                                    mobiledisable: true,
                                    title: "Invalid Card Number",
                                    cardType: "",
                                    mobileverification: false,
                                    mobilecardVerified: false,
                                    mobilerederFeedback: false,
                                    disabled: true
                                })

                                toast.error(apiMessage, {
                                    position: "top-right",
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    draggablePercent: 60
                                })
                            }).catch(function () {
                                const headerMessage = response.headers.get('message');

                                _this.setState({
                                    cardVerified: false,
                                    rederFeedback: false,
                                    verification: false,
                                    mobiledisable: true,
                                    title: "Invalid Card Number",
                                    cardType: "",
                                    mobileverification: false,
                                    mobilecardVerified: false,
                                    mobilerederFeedback: false,
                                    disabled: true
                                })

                                toast.error(headerMessage, {
                                    position: "top-right",
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    draggablePercent: 60
                                })
                            })
                        }
                        else {
                            _this.setState({ cardVerified: false, rederFeedback: true, verification: false, mobiledisable: true, title: "Invalid Card Number" })
                            // eslint-disable-next-line
                            toast.error(response.headers.get('message')), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            };

                        }
                    })
                    .finally(() => {
                        _this.isVerifyingCard = false;
                    })
            }
        }
        else {
            if (actualCardNumber.length < 16)
                this.setState({
                    verification: false,
                })
            this.lastCheckedCardNumber = null;
        }

    }



    checkDob(e) {
        const dobValue = e.target.value;

        if (this.state.verification === true && this.state.mobileverification === true) {
            this.setState({});
        } else {
            this.setState({ disabled: true });
        }

        const isComplete = dobValue.length === 4 && !dobValue.includes('_') && /^\d{4}$/.test(dobValue);

        if (!isComplete) {
            this.setState({ mobileverification: false });
            return;
        }

        this.setState({ mobilecardVerified: true, mobilerederFeedback: false, disabled: false });

        const encryptedCardNumber = localStorage.getItem('eCard');
        if (!encryptedCardNumber) return;

        const state = {
            cardNumber: encryptedCardNumber,
            applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
            dateOfBirth: dobValue,
        };

        const plink = localStorage.getItem('pform') === 'AU'
            ? process.env.REACT_APP_SERVICEURL_AU
            : process.env.REACT_APP_SERVICEURL_NZ;
        const gvvid = getClientId();
        const traceId = getClientId();
        const _this = this;

        fetch(plink + services.verify_dob_reg, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'clientId': gvvid,
                'clientSecret': getClientSecret(gvvid, dobValue),
                'X-Trace-Id': traceId,
                'X-Client-APP': buildClientHeader(),
            },
            body: JSON.stringify(state),
        })
            .then(response => {
                if (response.status === 200 || response.status === 204) {
                    if (_this.state.otpAuthentication === true) {
                        _this.setState({
                            mobilecardVerified: false,
                            mobilerederFeedback: true,
                            mobileverification: true,
                            mobileVerificationDone: true,
                            showOTPBtn: true,
                            showOTP: false,
                            disabled: true,
                        });
                    } else {
                        _this.setState({
                            mobilecardVerified: false,
                            mobilerederFeedback: true,
                            mobileverification: true,
                            mobileVerificationDone: true,
                            showOTPBtn: false,
                            showOTP: false,
                            disabled: false,
                        });
                    }
                }
                else if (response.status === 422 || response.status === 400) {
                    response.json().then(json => {
                        const message = (json && json.message) || response.headers.get('message');
                        toast.error(message, {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        });
                    }).catch(() => {
                        const message = response.headers.get('message') || 'Invalid Date of Birth';
                        toast.error(message, {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        });
                    });
                    _this.setState({
                        mobilecardVerified: false,
                        mobilerederFeedback: true,
                        mobileverification: false,
                        showOTPBtn: false,
                        showOTP: false,
                        disabled: true,
                    });
                }
                else if (response.status === 500) {
                    toast.error('Something went wrong. Please try again.', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                    _this.setState({
                        mobilecardVerified: false,
                        mobilerederFeedback: true,
                        mobileverification: false,
                        showOTPBtn: false,
                        showOTP: false,
                        disabled: true,
                    });
                }
                else {
                    toast.error(response.headers.get('message') || 'Unable to verify Date of Birth', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                    _this.setState({
                        mobilecardVerified: false,
                        mobilerederFeedback: true,
                        mobileverification: false,
                        showOTPBtn: false,
                        showOTP: false,
                        disabled: true,
                    });
                }
            })
            .catch(() => {
                toast.error('Unable to verify Date of Birth. Please try again.', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                _this.setState({
                    mobilecardVerified: false,
                    mobilerederFeedback: true,
                    mobileverification: false,
                    showOTPBtn: false,
                    showOTP: false,
                    disabled: true,
                });
            });
    }


    checkMobileNo(e) {
        const mobileValue = e.target.value;

        const isComplete = mobileValue.length === 4 && !mobileValue.includes('_') && /^\d{4}$/.test(mobileValue);
        if (!isComplete) return;

        const encryptedCardNumber = localStorage.getItem('eCard');
        if (!encryptedCardNumber) return;

        this.setState({ mobilecardVerified: true, mobilerederFeedback: false });

        const state = {
            cardNumber: encryptedCardNumber,
            applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
            mobileNumber: mobileValue,
        };

        const plink = localStorage.getItem('pform') === 'AU'
            ? process.env.REACT_APP_SERVICEURL_AU
            : process.env.REACT_APP_SERVICEURL_NZ;
        const gvvid = getClientId();
        const traceId = getClientId();
        const _this = this;

        fetch(plink + services.verify_mobileNo_reg, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'clientId': gvvid,
                'clientSecret': getClientSecret(gvvid, mobileValue),
                'X-Trace-Id': traceId,
                'X-Client-APP': buildClientHeader(),
            },
            body: JSON.stringify(state),
        })
            .then(response => {
                if (response.status === 200 || response.status === 204) {
                    // otpAuthentication comes from checkCardNumber's response, stored in state.
                    const otpRequired = _this.state.otpAuthentication === true;

                    if (otpRequired) {
                        // OTP flow: request-OTP button appears, no direct submit yet.
                        _this.setState({
                            mobileNoVerified: true,
                            mobilecardVerified: false,
                            mobileverification: false,
                            showOTPBtn: true,
                            showOTP: false,
                            disabled: true,
                        });
                    } else {
                        // No OTP needed: enable Submit right away.
                        // mobileverification:true is what makes the Submit button render
                        // (see the `showOTP || mobileverification` check in render()),
                        // and disabled:false enables it immediately since there's no
                        // OTP length to wait on.
                        _this.setState({
                            mobileNoVerified: true,
                            mobilecardVerified: false,
                            mobileverification: true,
                            mobileVerificationDone: true,
                            showOTPBtn: false,
                            showOTP: false,
                            disabled: false,
                        });
                    }
                }
                else if (response.status === 422 || response.status === 400) {
                    response.json().then(json => {
                        const message = (json && json.message) || response.headers.get('message');
                        toast.error(message, {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        });
                    }).catch(() => {
                        const message = response.headers.get('message') || 'Invalid Mobile Number';
                        toast.error(message, {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        });
                    });
                    _this.setState({ mobileNoVerified: false, mobilecardVerified: false, mobileverification: false, showOTPBtn: false, showOTP: false, disabled: true });
                }
                else if (response.status === 500) {
                    toast.error('Something went wrong. Please try again.', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                    _this.setState({ mobileNoVerified: false, mobilecardVerified: false, mobileverification: false, showOTPBtn: false, showOTP: false, disabled: true });
                }
                else {
                    toast.error(response.headers.get('message') || 'Unable to verify Mobile Number', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                    _this.setState({ mobileNoVerified: false, mobilecardVerified: false, mobileverification: false, showOTPBtn: false, showOTP: false, disabled: true });
                }
            })
            .catch(() => {
                toast.error('Unable to verify Mobile Number. Please try again.', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                _this.setState({ mobileNoVerified: false, mobilecardVerified: false, mobileverification: false, showOTPBtn: false, showOTP: false, disabled: true });
            });
    }
    handleModal(e) {
        if (e) { e.preventDefault() }
        this.setState({ open: !this.state.open })
    }

    closeUserModal = () => {
        this.setState({
            openModal: false
        })
    }

    onFieldChange = (e, value) => {
        this.setState({
            email: value
        }, () => {
            console.log(this.state.email)
        })

    }


    verifyCard = () => {

        let _this = this
        this.isVerifyingDigitalCard = true;

        const state = {
            kitNumber: this.state.cardref,
            applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex'
        }
        let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
        let gid = getClientId();
        let traceId = getClientId();
        fetch(plink + services.verifyDigitalCard, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'clientId': gid,
                'clientSecret': getClientSecret(gid, this.state.cardref),
                'X-Trace-Id': traceId,
                'X-Client-APP': buildClientHeader(),
            }),
            body: JSON.stringify(state)
        })
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                    localStorage.setItem("isDigitalCard", "true")

                    toast.success(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });

                    return response.text().then(function (text) {
                        let object = {};
                        if (text) {
                            try {
                                object = JSON.parse(text);
                            } catch (err) {
                                console.log('verifyDigitalCard: response body was not valid JSON', err);
                            }
                        }



                        // OTP is always required for digital card — skip the button,
                        // show the OTP field immediately and send it.
                        _this.setState({
                            disabled: true,
                            showOTPBtn: false,
                            showOTP: true,
                            verification: true,
                            otpValidation: true,
                            otpAuthentication: true,
                        }, () => {
                            _this.resendOTP();
                        })
                    })

                }
                else {
                    this.setState({
                        showOTPBtn: false,
                        showOTP: false,
                    })
                    toast.error(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                }
            })
            .finally(() => {
                _this.isVerifyingDigitalCard = false;
            })
    }
    sendOTP = () => {
        this.setState({
            showOTP: true,
            showOTPBtn: false,
        }, () => {
            this.resendOTP();
        })
    }
    resendOTP = () => {


        let _this = this

        const state = {
            action: "CARD_ACTIVATION",
            // kitNumber: this.state.cardref,
            kitNumber: this.state.cardref || this.state.refCardNo,
            applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex'
        }
        let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
        let grid = getClientId();
        let traceId = getClientId();
        fetch(plink + services.resendOTPForDigiCard, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'clientId': grid,
                // 'clientSecret': getClientSecret(grid, this.state.cardref),
                'clientSecret': getClientSecret(grid, this.state.cardref || this.state.refCardNo),

                'X-Trace-Id': traceId,
                'X-Client-APP': buildClientHeader(),
            }),
            body: JSON.stringify(state)
        })
            .then(response => {
                if (response.status === 200) {

                    toast.success(response.headers.get('message')), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    };
                    this.setState({
                        countdown: 300,
                        showResend: true
                    }, () => {
                        this.startTimer()
                    })
                }

                else {
                    //_this.setState({ cardVerified: false, rederFeedback: true, verification: false, mobiledisable: true, title: "Invalid Card Number" })
                    // eslint-disable-next-line
                    toast.error(response.headers.get('message')), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    };

                }
            })
    }




    getVerifyWithOTP = () => {

        let _this = this
        const otpRequired = localStorage.getItem("otpAuthentication");
        const state = {
            ...(otpRequired ? { otp: this.state.otp } : {}),
            action: "CARD_ACTIVATION",
            kitNumber: this.state.cardref || this.state.refCardNo,
            applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex'
        }
        let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
        let gvid = getClientId();
        let traceId = getClientId();
        fetch(plink + services.verifyDigitalCardWithOtp, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'clientId': gvid,
                'clientSecret': getClientSecret(gvid, ""),
                'X-Trace-Id': traceId,
                'X-Client-APP': buildClientHeader(),
            }),
            body: JSON.stringify(state)
        })
            .then(response => {

                if (response.status === 200) {

                    response.json().then(function (object) {
                        _this.setState({
                            cardVerified: false,
                            cardStatus: object.cardStatus
                        })
                        let dob = object.specialDate
                        JSON.stringify(localStorage.setItem('dob', dob))

                        const resolvedCardType = object.cardType || 'A';   // fallback if API omits it

                        localStorage.setItem("cardType", resolvedCardType)

                        localStorage.setItem("otpAuthentication", object.otpAuthentication)
                        localStorage.setItem("existingUser", object.accountIdExist)
                        // Needed by handleVerify() for digital cards — previously these
                        // weren't stored, so handleVerify sent empty strings and the
                        // backend rejected idExpiry (expects yyyy-MM-dd).




                        const public_Key = _this.props.publicKey.body.publickey;
                        let encrypt = new JSEncrypt();
                        encrypt.setPublicKey(public_Key);
                        // let encrypted = encrypt.encrypt(object.cardNumber);
                        // _this.props.storeCardNumber(encrypted)
                        // localStorage.setItem("cardNumber", encrypted)

                        // _this.props.getactivation(state)
                    })
                    toast.success(response.headers.get('message')), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    };


                    // JSON.stringify(localStorage.setItem('step', 1))
                    JSON.stringify(localStorage.setItem('step', 0))

                    _this.props.history.push('/activate-card')

                }

                else {
                    response.json().then(function (object) {
                        const apiMessage = (object && object.message) || response.headers.get('message') || 'Invalid OTP';

                        _this.setState({
                            disabled: true,
                        })

                        toast.error(apiMessage, {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                    }).catch(function () {
                        const headerMessage = response.headers.get('message') || 'Invalid OTP';

                        _this.setState({
                            disabled: true,
                        })

                        toast.error(headerMessage, {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                    })
                }
            })
    }


    onOtpChange = (e, value) => {
        this.setState({
            otp: value,
        }, () => {
            this.setState({
                disabled: !(this.state.otp && this.state.otp.length === 6)
            })
        })
    }

    onCardRefChange = (e, value) => {
        this.setState({
            cardref: value,
        }, () => {
            // if (this.state.cardref.length === 10) {
            //     this.transition();
            //     this.verifyCard();
            //     //this.startTimer();
            // }
            if (this.state.cardref.length >= getMinCardRefLength()) {
    this.transition();
    this.verifyCard();
    //this.startTimer();
}

            if (this.state.cardref.length > 0) {
                this.setState({ isPhysical: false, isDigital: true })
            }
            else {
                this.setState({ isPhysical: true, isDigital: true, disabled: true, showOTP: false })
            }
            console.log(this.state.cardref)
            localStorage.setItem("kitNumber", this.state.cardref)
        })

    }

    toggleModal = () => this.setState({
        showModal: !this.state.showModal
    })

    handleSendLink = () => {
        let _this = this
        let state = {
            emailId: this.state.email
        }
        let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ

        let gsid = getClientId();
        let traceId = getClientId();
        fetch(plink + services.send_api_link, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'clientId': gsid,
                'clientSecret': getClientSecret(gsid, this.state.emailId),
                'X-Trace-Id': traceId,
                'X-Client-APP': buildClientHeader(),
            }),
            body: JSON.stringify(state)
        })
            .then(
                function (response) {
                    if (response.status === 200 || response.status === 201 || response.status === 204) {
                        _this.setState({
                            showModal: false,
                            email: '',
                        })
                        toast.success(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                    }
                    else if (response.status === 400) {
                        toast.error("Incorrect Email ID.", {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                    }
                    else {
                        toast.error(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                    }
                }
            )
    }
    clearTimer() {
        if (this.timer) clearInterval(this.timer);

        console.log('do stuff')
        this.childRef.clearTimeInterval()
        alert("Executed")
    }
    getAlert = () => {
        alert('child clicked');
    }
    startTimer = () => {
        if (this.timer) clearInterval(this.timer);

        //this.workerTimerId = workerTimers.setInterval(this.setSeconds, 1000);
        this.timer = setInterval(() => this.tick(), 1000);
    }
    tick = () => {
        const current = this.state.countdown;

        this.setState({
            countdown: current - 1
        }, () => {
            if (current === 1) {
                this.setState({
                    showResend: false,
                })
            }
            if (current <= 0) {
                //this.transition();
                this.setState({ countdown: current - 1 });
                //this.handleLogout();
            }

            if (current === 0) {
                this.transition();
                let cdown = 300
                this.setState({
                    countdown: cdown ? cdown : 0,
                    showResend: false,
                })
            }
        });
    }
    transition = () => {
        clearInterval(this.timer);
        // do something else here, presumably.
    }
    setSeconds = () => {
        this.setState({
            workerTime: this.state.workerTime - 1
        });
    };
    resetMobileAndOtp = () => {
        if (this.timer) clearInterval(this.timer);

        this.setState({
            mobile: '',
            mobileverification: false,
            mobileVerificationDone: false,
            mobilecardVerified: false,
            mobilerederFeedback: false,

            showOTP: false,
            showOTPBtn: false,
            otp: '',

            mobiledisable: true,
            countdown: 300,
            showResend: false,
        });

        const mobileInput = document.getElementById('phonenumber');
        if (mobileInput) {
            mobileInput.value = '';
        }
    }
    render() {
        const { cardVerified, loader, verification, rederFeedback, mobilecardVerified, mobileverification, mobilerederFeedback } = this.state

        console.log("Height in here ", this.state.height)
        console.log("Email ", this.state.emailId)
        return (
            <div className="" >
                <ToastContainer
                    position="top-right"
                    autoClose={4000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                />
                <section className="row mb-3" id="statictopbar" style={{ padding: "15px 0px", background: '#0190f7' }}>
                    <div className="col-sm-12" > </div>
                </section>
                <GusetNavbar />
                <div className="" style={{ backgroundColor: 'transparent' }}>
                    {this.state.openModal &&
                        <UserModal
                            open={this.state.openModal}
                            onClose={this.closeUserModal}
                            handleOld={this.handleOldUser}
                            handleNew={this.handleNewUser}
                        />}
                    {/* <ToastContainer
                        draggablePercent={60}
                        position="top-right"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop
                        closeOnClick
                        rtl={false}
                        pauseOnVisibilityChange
                        draggable={false}
                        pauseOnHover
                    /> */}
                    <div

                        className={`modal WelcomeModal ${this.state.showModal ? 'show' : ''}`}
                        style={{
                            display: `${this.state.showModal ? 'block' : 'none'}`,
                            backgroundColor: "rgba(12,12,12,.5)"
                        }}
                        id="WelcomeModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header" style={{ borderBottom: "0px" }}>
                                    <div className="camera-box">
                                        <h5 className="modal-title" id="exampleModalLabel">Download Mobile App</h5>
                                    </div>
                                    <button type="button" class="close" onClick={this.toggleModal} data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <p>The SIMS Visa Prepaid App is now available.  You can download the mobile App by clicking on the logos below. </p>
                                    <div className="col-sm-12 ">
                                        <div className="row">
                                            <div className="col-sm-8" style={{ paddingLeft: "5px" }} >

                                                <TextField
                                                    hintText="Email"
                                                    floatingLabelText="Email"
                                                    type="text"
                                                    name="email"
                                                    maxLength="50"
                                                    autoComplete='off'
                                                    onChange={this.onFieldChange}
                                                    className="my-className"
                                                    underlineFocusStyle={styles.focusStyle}
                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                    autoFocus={true}
                                                    fullWidth
                                                />

                                            </div>
                                            <div className="col-sm-4" style={{ marginTop: "25px", padding: "0px" }}>
                                                <RaisedButton
                                                    label="Send App Link"
                                                    labelColor="#000"
                                                    className="btn-std"
                                                    // style={styles.buttonStyle}
                                                    buttonStyle={{ height: "30px", lineHeight: "0px" }}
                                                    labelStyle={{ paddingLeft: "12px", paddingRight: "12px", textTransform: "capitalize" }}
                                                    onClick={this.handleSendLink.bind(this)}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <p className='mt-4 pb-1'><a href="https://play.google.com/store/apps/details?id=com.oxy.sims" target="_blank"><img src={android} style={{ height: '55px', marginRight: "6px" }} /></a> <a href="https://apps.apple.com/in/app/simsmetal/id1670414151" target="_blank"><img src={ios} style={{ height: '55px' }} /> </a></p>
                                    <p className='mt-1 pb-1'>On the App, you can perform all the functions that are available on the website klickex.co.nz such as Card Activation, Registration, Lock/Unlock card, Change PIN, Transaction History, Print Statement and much more.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-md-12 cardbgNZ'>
                        <div className='container bgtransparent'>
                            <div className="col-sm-12 " >
                                <div className="row" >
                                    <div className="col-md-6 card-images pl-4 pr-0 pt-2" >
                                        <h2> KlickEx Money Card</h2>
                                        <h2> makes using your</h2>
                                        <h2> money in <span>New Zealand <img className='highlitedau' src={highlitedtext} alt='New Zealand' /></span></h2>
                                        <h2> a breeze</h2>
                                        <div className='col-md-12' >
                                            <img className='aucardholder' src={nzcardholder} alt='' />
                                        </div>

                                    </div>

                                    <div className="col-md-6 pl-0 mr-0 pr-0" >
                                        <div className="d-flex flex-row-begin" style={{ marginTop: 40 }}>
                                            <div className="loginbox col-auto justify-content-end  p-4 mb-5">
                                                <div className="col-12 mt-2">
                                                    <div className="logmainheading mb-3">Activate/Register <span style={{ color: '#0190f7' }}> Your Card </span></div>
                                                </div>
                                                {this.state.isPhysical === true &&
                                                    <React.Fragment>
                                                        <div className="col-12">
                                                            <div className="row">
                                                                <div className="col-12 mb-4">
                                                                    <div className="row">
                                                                        <div className="col-11">
                                                                            {/* <label style={{ fontSize: "14px", }}>Card Reference Number ? </label> */}
                                                                            {/* <label style={{ fontSize: "14px", display: 'flex', alignItems: 'center' }}>
    Card Reference Number
    <span
        style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '16px',
            height: '16px',
            borderRadius: '50%',
            backgroundColor: '#0190f7',
            color: '#fff',
            fontSize: '11px',
            fontWeight: 'bold',
            marginLeft: '6px',
            cursor: 'pointer',
            position: 'relative'
        }}
        onMouseEnter={() => this.setState({ showCardRefTooltip: true })}
        onMouseLeave={() => this.setState({ showCardRefTooltip: false })}
    >
            <i className="fa fa-question-circle" aria-hidden="true"></i>
 
     
        {this.state.showCardRefTooltip &&
    <div style={{
        position: 'absolute',
        top: '50%',
        left: '24px',
        transform: 'translateY(-50%)',
        backgroundColor: '#333',
        color: '#fff',
        padding: '8px 12px',
        borderRadius: '6px',
        fontSize: '12px',
        fontWeight: 'normal',
        width: '260px',
        lineHeight: '1.4',
        zIndex: 1000,
        textAlign: 'left'
    }}>
        The Card Reference Number is located on the back of your Card. Look for Card Ref ID and enter the 10 digit number
        <div style={{
            position: 'absolute',
            top: '50%',
            right: '100%',
            transform: 'translateY(-50%)',
            width: 0,
            height: 0,
            borderTop: '6px solid transparent',
            borderBottom: '6px solid transparent',
            borderRight: '6px solid #333'
        }}></div>
    </div>
}
    </span>
</label> */}
                                                                            <label style={{ fontSize: "14px", display: 'flex', alignItems: 'center' }}>
                                                                                Enter Card Reference Number
                                                                                <span
                                                                                    style={{
                                                                                        display: 'inline-flex',
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center',
                                                                                        marginLeft: '6px',
                                                                                        cursor: 'pointer',
                                                                                        position: 'relative',
                                                                                        color: '#0190f7',
                                                                                        fontSize: '15px',
                                                                                        lineHeight: 1,
                                                                                        transition: 'color 0.15s ease'
                                                                                    }}
                                                                                    onMouseEnter={() => this.setState({ showCardRefTooltip: true })}
                                                                                    onMouseLeave={() => this.setState({ showCardRefTooltip: false })}
                                                                                    onMouseOver={(e) => e.currentTarget.style.color = '#0170c7'}
                                                                                    onMouseOut={(e) => e.currentTarget.style.color = '#0190f7'}
                                                                                >
                                                                                    <i className="fa fa-question-circle" aria-hidden="true"></i>

                                                                                    {this.state.showCardRefTooltip &&
                                                                                        <div style={{
                                                                                            position: 'absolute',
                                                                                            top: '50%',
                                                                                            left: '22px',
                                                                                            transform: 'translateY(-50%)',
                                                                                            backgroundColor: '#333',
                                                                                            color: '#fff',
                                                                                            padding: '8px 12px',
                                                                                            borderRadius: '6px',
                                                                                            fontSize: '12px',
                                                                                            fontWeight: 'normal',
                                                                                            width: '260px',
                                                                                            lineHeight: '1.4',
                                                                                            zIndex: 1000,
                                                                                            textAlign: 'left'
                                                                                        }}>
                                                                                            The Card Reference Number is located on the back of your Card. Look for Card Ref ID and enter the 10 digit number
                                                                                            <div style={{
                                                                                                position: 'absolute',
                                                                                                top: '50%',
                                                                                                right: '100%',
                                                                                                transform: 'translateY(-50%)',
                                                                                                width: 0,
                                                                                                height: 0,
                                                                                                borderTop: '6px solid transparent',
                                                                                                borderBottom: '6px solid transparent',
                                                                                                borderRight: '6px solid #333'
                                                                                            }}></div>
                                                                                        </div>
                                                                                    }
                                                                                </span>
                                                                            </label>
                                                                            <TextField
                                                                                type="text"
                                                                                name="refCardNo"
                                                                                placeholder="Card Reference Number"
                                                                                autoComplete='off'
                                                                                onChange={this.onRefCardNoChange}
                                                                                onBlur={this.onRefCardNoBlur}
                                                                                className="my-className"
                                                                                // underlineFocusStyle={styles.focusStyle}
                                                                                // floatingLabelFocusStyle={styles.focusTextStyle}
                                                                                // disabled={this.state.refCardNoDisabled}
                                                                                underlineFocusStyle={styles.focusStyle}
                                                                                floatingLabelFocusStyle={styles.focusTextStyle}
                                                                                disabled={this.state.refCardNoDisabled}
                                                                                underlineDisabledStyle={styles.underlineDisabledStyle}
                                                                                fullWidth
                                                                            // onPaste={(e) => e.preventDefault()}
                                                                            // onCopy={(e) => e.preventDefault()}
                                                                            // onCut={(e) => e.preventDefault()}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-11">

                                                                    <div className="group">
                                                                        <InputMask mask="9999-9999-9999-9999" autoComplete='none' placeholder="1234-1234-1234-1234" onChange={this.checkCardNumber.bind(this)}
                                                                            id="cardNumber"
                                                                            //                                                                            onPaste={(e) => e.preventDefault()}
                                                                            // onCopy={(e) => e.preventDefault()}
                                                                            // onCut={(e) => e.preventDefault()}
                                                                            ref="item" />
                                                                        <span className="highlight"></span>
                                                                        <span className="bar"></span>
                                                                        <label className="lblcardactivate">Enter the 16 digit number from the back of your physical card</label>

                                                                    </div>

                                                                    {cardVerified ? <LoaderSmall /> : null}
                                                                    {/* {rederFeedback ? <div className="feedback">
                                                                        {verification ? <i className="fa fa-check" aria-hidden="true" style={{ color: "green", marginLeft: "3px" }}></i> :
                                                                            <i className="fa fa-times" aria-hidden="true" style={{ color: "red" }}></i>}
                                                                    </div> : null} */}

                                                                    {/*  */}
                                                                </div>
                                                            </div>
                                                         
                                                        </div>
                                                        {/* {(this.state.cardType === "G" || this.state.cardType === "R") ?
                                                            <div className="col-12">
                                                                <div className="row">
                                                                    <div className="col-11">
                                                                        <label style={{ fontSize: "14px", }}>Date Of Birth </label>
                                                                        <div className="group" style={{ marginTop: "0px" }}>
                                                                            <InputMask mask="9999" placeholder="DDMM" title={this.state.title} autoComplete='none' readOnly={this.state.mobiledisable} onChange={this.checkDob.bind(this)}
                                                                                id="phonenumber"
                                                                                onPaste={(e) => e.preventDefault()}
                                                                                onCopy={(e) => e.preventDefault()}
                                                                                onCut={(e) => e.preventDefault()} />
                                                                        </div>

                                                                        {mobilecardVerified ? <LoaderSmall /> : null}
                                                                
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            :
                                                            <div>
                                                            </div>
                                                        } */}
                                                        {(this.state.cardType === "G" || this.state.cardType === "R") ?
                                                            <div className="col-12">
                                                                <div className="row">
                                                                    <div className="col-11">
                                                                        <label style={{ fontSize: "14px", }}>Mobile Number </label>
                                                                        <div className="group" style={{ marginTop: "0px" }}>
                                                                            <InputMask mask="9999" placeholder="Last 4 digits" title={this.state.title} autoComplete='none' readOnly={this.state.mobiledisable} onChange={this.checkMobileNo.bind(this)}
                                                                                id="phonenumber"
                                                                                onPaste={(e) => e.preventDefault()}
                                                                                onCopy={(e) => e.preventDefault()}
                                                                                onCut={(e) => e.preventDefault()} />
                                                                        </div>

                                                                        {mobilecardVerified ? <LoaderSmall /> : null}                                                                        {/* {mobilerederFeedback ? <div className="feedback">
                                                                            {mobileverification ? <i className="fa fa-check" aria-hidden="true" style={{ color: "green" }}></i> :
                                                                                <i className="fa fa-times" aria-hidden="true" style={{ color: "red" }}></i>}
                                                                        </div> : null} */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            :
                                                            <div>
                                                            </div>
                                                        }
                                                    </React.Fragment>
                                                }

                                                {this.state.isDigital === true &&
                                                    <React.Fragment>
                                                        <div className="col-12 ">
                                                            <div className="subTitle mb-1">Don't have a physical card ?</div>
                                                        </div>

                                                        <div className="col-12">
                                                            <div className="row">
                                                                <div className="col-11">
                                                                    <label style={{ fontSize: "14px", }}>Enter your digital card reference number </label>
                                                                    <TextField
                                                                        type="text"
                                                                        name="cardref"
                                                                        maxLength="10"

                                                                        autoComplete='off'
                                                                        onChange={this.onCardRefChange}
                                                                        className="my-className"
                                                                        underlineFocusStyle={styles.focusStyle}
                                                                        floatingLabelFocusStyle={styles.focusTextStyle}
                                                                        autoFocus={true}
                                                                        fullWidth
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </React.Fragment>
                                                }
                                                {this.state.showOTPBtn &&
                                                    <RaisedButton
                                                        label="Request a One-time password (OTP) to be sent to your email address"
                                                        className="card-submit btn-std btn-block"
                                                        backgroundColor="#FFCE39"
                                                        labelColor="#115876"
                                                        buttonStyle={{ borderRadius: 24 }}
                                                        style={{ borderRadius: 24 }}
                                                        onClick={this.sendOTP}
                                                    />
                                                }

                                                {this.state.showOTP &&
                                                    <React.Fragment>
                                                        <div className="col-11">
                                                            <TextField
                                                                hintText="Enter OTP"
                                                                floatingLabelText="Enter OTP"
                                                                type="text"
                                                                name="otp"
                                                                maxLength="6"
                                                                value={this.state.otp}
                                                                autoComplete='off'
                                                                onChange={this.onOtpChange}
                                                                className="my-className"
                                                                underlineFocusStyle={styles.focusStyle}
                                                                floatingLabelFocusStyle={styles.focusTextStyle}
                                                                autoFocus={true}
                                                                fullWidth
                                                            />
                                                        </div>
                                                        <div className="col-11 mt-2 text-right">
                                                            {this.state.showResend === false ?
                                                                <span
                                                                    className="resendotp textsmall"
                                                                    // style={{ color: "#FFCE39", cursor: "pointer" }}
                                                                    style={{ color: "#F5820D", fontWeight: 600, cursor: "pointer" }}

                                                                    onClick={this.resendOTP}
                                                                >
                                                                    Resend OTP
                                                                </span>
                                                                :
                                                                <span className="text-right textsmall"
                                                                    //  style={{ color: "#FFCE39" }}
                                                                    style={{ color: "#F5820D", fontWeight: 600, cursor: "pointer" }}
                                                                >
                                                                    Resend OTP in: {this.state.countdown} sec.
                                                                </span>
                                                            }
                                                        </div>
                                                    </React.Fragment>
                                                }
                                                {(this.state.showOTP || this.state.mobileverification) &&
                                                    <div className='col-12 mt-4 text-center'>
                                                        <RaisedButton
                                                            // disabled={this.state.disabled}
                                                            disabled={this.state.showOTP ? !(this.state.otp && this.state.otp.length === 6) : this.state.disabled}
                                                            label="Submit"
                                                            className="card-submit btn-std btn-block"
                                                            backgroundColor="#FFCE39"
                                                            labelColor="#115876"
                                                            buttonStyle={{ borderRadius: 24 }}
                                                            style={{ borderRadius: 24 }}
                                                            onClick={this.storeCard}
                                                        />
                                                        {/* <Link to='/login' className='simplelink text-center' style={{ display: 'block' }}> Sign in to your card account
                                                    <i style={{ color: "#115876", fontSize: "17px" }} className="fa fa-arrow-circle-right ml-2"></i>
                                                </Link> */}
                                                    </div>
                                                }
                                                <div className='col-12 mt-4 text-center'>
                                                    <Link to='/login' className='simplelink text-center' style={{ display: 'block' }}> Sign in to your card account
                                                        <i style={{ color: "#115876", fontSize: "17px" }} className="fa fa-arrow-circle-right ml-2"></i>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12" style={{ backgroundColor: 'rgb(233 248 253)' }}>
                        <div className='container bgtransparent'>
                            <div className="col-sm-12 " >
                                <div className="row mb-1  pt-5" style={{ marginTop: '-8px' }}>
                                    <div className="col-md-10 offset-md-2 text-left subdetails" >
                                        <h4>Choose the New Zealand KlickEx Money Card and make <br />
                                            Shopping, spending and accessing your money simple<br />
                                            while you are away.<br /></h4>
                                    </div>
                                    <div className="col-md-12 card-images text-center" style={{ position: "relative" }}>
                                        <h2 className='mt-3 pb-2 text-center'>With KlickEx <span>Money Card<img className='moneycardnz' src={highlitedtext} alt='nzl' /> </span>  you can...</h2>
                                    </div>
                                </div>
                                <div className="row pb-5 mt-5" >
                                    <div className="col-md-12 " >
                                        <section className="row" id="features" style={{ padding: "15px 0px" }}>
                                            <div className="col-md-4 col-sm-12 p-0 m-0 text-dark ">
                                                <div className="featuresgolden text-center wow zoomIn" data-wow-delay=".1s">
                                                    <img src={activateImg} alt='activate' />
                                                    <h4 className=" mt-3">SHOP NOW</h4>
                                                    <h5 className=" mt-3">Shop, spend & Travel <br /> with your card</h5>
                                                    <ul className="text-left">
                                                        <li className="text-left" >Accessible Anywhere</li>
                                                        <li className="text-left" >Worldwide Visa Acceptance - 24,000,000+ locations</li>
                                                        <li className="text-left" >Secure Online Shopping</li>
                                                        <li className="text-left" >Use in New Zealand and Overseas</li>
                                                    </ul>

                                                </div>
                                            </div>
                                            <div className="col-md-4 col-sm-12  p-0 m-0  text-dark ">

                                                <div className="featuressky text-center wow zoomIn" data-wow-delay=".3s">
                                                    <img src={manageImg} alt='manage' />

                                                    <h4 className=" mt-3">MANAGE YOUR ACCOUNT</h4>
                                                    <h5 className=" mt-3">Self manage your card <br /> easily</h5>
                                                    <ul className="text-left">
                                                        <li className="text-left" >Check Your Card Balance</li>
                                                        <li className="text-left" >View Your Transaction History</li>
                                                        <li className="text-left" >Set and/or Change Your PIN</li>
                                                        <li className="text-left" >Update Your Personal Details</li>
                                                    </ul>

                                                </div>
                                            </div>
                                            <div className="col-md-4 col-sm-12 p-0 m-0 text-dark ">
                                                <div className=" featuresblack text-center wow zoomIn" data-wow-delay=".5s">
                                                    <img src={customerImg} alt='Customer' />

                                                    <h4 className=" mt-3">CUSTOMER SERVICE</h4>
                                                    <h5 className=" mt-3">Get help when you <br />need it</h5>
                                                    <ul >
                                                        <li className="text-left" >24-7 Online Access</li>
                                                        <li className="text-left" >Email Customer Service </li>
                                                    </ul>

                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ActivateNz));


// WEBPACK FOOTER //
// ./src/components/register/nz.jsx